import { ButtonFlavor, ButtonSize, ButtonType, ExButton, ExIcon, IconSize } from '@boomi/exosphere';
import { useRef, useState } from 'react';
import './products-menu.css';
import classNames from 'classnames';
import { useClickOutside } from '../utils/useClickOutside';

const ProductsMenu = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const popupRef = useRef<HTMLDivElement>(null);
    const buttonRef = useRef<HTMLButtonElement>(null);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    useClickOutside([popupRef, buttonRef], () => setIsMenuOpen(false), isMenuOpen);

    const accountId = '';

    const products = [
        {
            name: 'Integration',
            icon: '/img/integration-icon.svg',
            url: `https://platform.boomi.com/AtomSphere.html#build;accountId=${accountId}`,
        },
        {
            name: 'Agent Garden',
            icon: '/img/ai-studio-icon.svg',
            url: `https://platform.boomi.com/BoomiAI.html#ai;accountId=${accountId}`,
        },
        {
            name: 'Agent Control Tower',
            icon: '/img/ai-controltower-icon.svg',
            url: 'https://ai-control-tower.boomi.com/',
        },
        {
            name: 'Task Automation',
            icon: '/img/task-automation-icon.svg',
            url: 'https://us.taskautomation.boomi.com/',
        },
        {
            name: 'Event Streams',
            icon: '/img/event-streams-icon.svg',
            url: `https://platform.boomi.com/EventStreams.html#es_environments;accountId=${accountId}`,
        },
        { name: 'Flow', icon: '/img/flow-icon.svg', url: 'https://flow.boomi.com/' },
        {
            name: 'API Management',
            icon: '/img/apim-icon.svg',
            url: `https://platform.boomi.com/ApiSphere.html#api_apis;accountId=${accountId}`,
        },
        {
            name: 'DataHub',
            icon: '/img/data-hub-icon.svg',
            url: `https://platform.boomi.com/MdmSphere.html#mdm_repositories;accountId=${accountId}`,
        },
        {
            name: 'Data Integration',
            icon: '/img/data-integration-icon.svg',
            url: 'https://console.rivery.io/',
        },
        {
            name: 'Marketplace',
            icon: '/img/marketplace-icon.svg',
            url: 'https://platform.boomi.com/login.html?signinRedirect=aHR0cHM6Ly9kaXNjb3Zlci5ib29taS5jb20v',
        },
        {
            name: 'Labs',
            icon: '/img/labs-icon.svg',
            url: 'https://boomi.com/boomi-labs/',
        },
    ];

    return (
        <div className="products-menu">
            <button
                ref={buttonRef}
                className="products-menu-button"
                title="Products"
                type="button"
                onClick={toggleMenu}
            >
                <ExIcon icon="Dotsnine" size={IconSize.M} />
            </button>
            {isMenuOpen && (
                <div className="products-menu-content" ref={popupRef}>
                    <div className="products-menu-header">
                        <span>Boomi Enterprise Platform</span>
                        <ExButton
                            className="home-button"
                            flavor={ButtonFlavor.BRANDED}
                            type={ButtonType.SECONDARY}
                            onClick={() => {
                                window.open(
                                    `https://platform.boomi.com/Home.html#home;accountId=${accountId}`,
                                    '_blank',
                                );
                                setIsMenuOpen(false);
                            }}
                            size={ButtonSize.SMALL}
                        >
                            <ExIcon icon="Home" slot="prefix" />
                            Home
                        </ExButton>
                    </div>
                    <div className="products-grid">
                        {products.map((product) => (
                            <a
                                key={product.name}
                                className="product-button"
                                href={product.url}
                                target="_blank"
                                onClick={() => setIsMenuOpen(false)}
                            >
                                <img
                                    className={classNames('product-icon', {
                                        'smaller-icon': ['Marketplace', 'Labs'].includes(
                                            product.name,
                                        ),
                                    })}
                                    src={product.icon}
                                    alt={`${product.name} icon`}
                                />
                                <span>{product.name}</span>
                            </a>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProductsMenu;
